import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "columns is-multiline" }
const _hoisted_2 = { class: "column is-6-desktop is-12-tablet is-12-mobile" }
const _hoisted_3 = { class: "column is-6-desktop is-12-tablet is-12-mobile" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormInput = _resolveComponent("FormInput")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_FormInput, {
        id: "cp-input",
        label: "Código Postal",
        modelValue: _ctx.postalCode,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.postalCode) = $event)),
        placeholder: "0000-000",
        "max-length": "8",
        required: "",
        "validation-pattern": /^\d{4}-\d{3}$/
      }, null, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_FormInput, {
        id: "localidade-input",
        label: "Localidade",
        modelValue: _ctx.city,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.city) = $event)),
        placeholder: "Cidade",
        "max-length": "50",
        required: "",
        "custom-validator": (value) => value.length >= 2 && value.length <= 50
      }, null, 8, ["modelValue", "custom-validator"])
    ])
  ]))
}